export default "__VITE_ASSET__17051ccc__"